import { useEffect, useState } from "preact/hooks";
import type { App } from "../app.ts";

/** The app's state, re-read whenever any part of it changes. */
export function useAppState(app: App) {
  const [state, setState] = useState(app.state.get());
  useEffect(() => {
    setState(app.state.get());
    return app.state.subscribe((next) => setState(next)) as () => void;
  }, [app]);
  return state;
}
